import { render, staticRenderFns } from "./take-tongue-three.vue?vue&type=template&id=489281df&scoped=true&"
import script from "./take-tongue-three.vue?vue&type=script&lang=ts&"
export * from "./take-tongue-three.vue?vue&type=script&lang=ts&"
import style0 from "./take-tongue-three.vue?vue&type=style&index=0&id=489281df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489281df",
  null
  
)

export default component.exports